import request from '@utils/request'

export const getObjectDetailId = objectId => request.get(`/api_v3/studio/objects/${objectId}`)
